module.exports = __webpack_public_path__ + "static/homepage-cloud-editor-06507e57756ce2c28890cb11394adcf8.jpg";